import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import '../css/NavMenu.css';

const NavMenu = (props) => {
    const url = props.url;

    const navMenuMain =
        <Nav fill pills>
            <NavItem>
                <NavLink
                    tag={Link}
                    active={url === "/portfolio"}
                    className={"text-link"}
                    to={"/portfolio"}
                >
                    Portfolio
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink
                    tag={Link}
                    active={url === "/dashboard"}
                    className={"text-link"}
                    to={"/dashboard"}
                >
                    Dashboard
                </NavLink>
            </NavItem>
        </Nav>;

    const isSuperAdmin = props.role === 999;

    const navMenuAdmin =
        <Nav fill pills>
            <NavItem>
                <NavLink
                    tag={Link}
                    active={url === "/portfolio"}
                    className={"text-link"}
                    to={"/portfolio"}
                >
                    Portfolio
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink
                    tag={Link}
                    active={url === "/dashboard"}
                    className={"text-link"}
                    to={"/dashboard"}
                >
                    Dashboard
                </NavLink>
            </NavItem>

            {isSuperAdmin &&
                <NavItem>
                    <NavLink
                        tag={Link}
                        active={url.startsWith("/tasklist-templates")}
                        className={"text-link"}
                        to={"/tasklist-templates"}
                    >
                        Tasklist Templates
                    </NavLink>
                </NavItem>
            }
            {/* hide this feature for now*/}
            {false && isSuperAdmin &&
                <NavItem>
                    <NavLink
                        tag={Link}
                        active={url === "/email-templates"}
                        className={"text-link"}
                        to={"/email-templates"}
                    >
                        Email Templates
                    </NavLink>
                </NavItem>
            }

            <NavItem>
                <NavLink
                    tag={Link}
                    active={url === "/configuration"}
                    className={"text-link"}
                    to={"/configuration"}
                >
                    Administration
                </NavLink>
            </NavItem>

            {isSuperAdmin &&
                <NavItem>
                    <NavLink
                        tag={Link}
                        active={url === "/user-management"}
                        className={"text-link"}
                        to={"/user-management"}
                    >
                        User Management
                    </NavLink>
                </NavItem>
            }

            {isSuperAdmin && 1 === 2 && 
                <NavItem>
                    <NavLink
                        tag={Link}
                        active={url === "/audit-log"}
                        className={"text-link"}
                        to={"/audit-log"}
                    >
                        Audit Log
                    </NavLink>
                </NavItem>
            }
        </Nav>;

    const navMenuNone = <hr/>;

    const getMenu = (kind) => {
        switch (kind) {
            case "main":
                return navMenuMain;

            case "admin":
                return navMenuAdmin;

            default:
                return navMenuNone;
        }
    };

    const navMenu = getMenu(props.kind);

    return (
        <>
            {navMenu}
        </>
    );
}

export default NavMenu;
